module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAABIUlEQVRIiaXVsUoDQRDG8d8eNnZ2aW0UCyst8xIWBgVF8GEEn0MSLSx8CitJJ/gMAQvBPmORE44kd7u52+p255v/dywzsykijnGPD7yllELPFREJFzjFU4qIR+zX8Xe89jGowROM66PfCp8NzRiTWjgEDF8VnjHva9ACnuMl1YIKtzhvCLJX1AGeppSWqSHcySAHhrSWUGRQAt6AlxiUgrfCcwal4FZ4h8ECoxJwJ7zDoAgMVRe8TpzhZy20yIGz8PrPb3CwFhrhMtdorfCWK/lufGc7eSu8o1oe7DAqNuCZOl9iWmrQt0OLdENmS1Y/dCp25qW+4BKDPVz3BbNqtIiY1tt/zhjLCkd9wU0Dm1V0liLiEHdWb+nQ17/CFU4w+wOKrdwh5k6OIQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_04.png
// module id = fF40
// module chunks = 1